import { get } from 'lodash/object';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CacheService } from '../global/ng2-cache/services/cache.service';
import { SessionService } from '../services/session2.service';
import { ShortUrlService } from '../services/shorturl.service';

@Component({
  selector: 'app-goto',
  templateUrl: './goto.component.html',
  styleUrls: ['./goto.component.scss']
})
export class GotoComponent implements OnInit {

  session: any;

  constructor(
    private cacheService: CacheService,
    private router: Router,
    private route: ActivatedRoute,
    private shortUrlService: ShortUrlService,
    private sessionService: SessionService
  ) { }

  ngOnInit() {
    // The sessionService will kick the user back to the login page if needed.
    this.session = this.cacheService.get('session');
    if (!this.session) {
      this.sessionService.getSession(true).subscribe(
        (session: any) => {
          this.session = session;
          this.initView();
        }
      );
    }
    else {
      this.initView();
    }
  }

  initView() {
    let id = this.route.snapshot.params['id'];
    this.shortUrlService.getById(id).subscribe(
      (result: any) => {
        if (!result) {
          // no URL found (or is in a different account) send to dashboard
          // todo: at some point we could redirect to the target account if needed
          this.router.navigate(['/']);
        }

        // a short URL can have a session with it.
        // whatever is in that session will replace what is in
        // the user's session for the same key.
        if (result.session) {
          for (let key in result.session) {
            if (this.session[key]) {
              this.session[key] = result.session[key];
              if (typeof this.session[key] === 'object') {
                this.session[key].last_changed = new Date();
              }
            }
          }
        }
        const queryParams = get(result, 'queryParams', null);
        this.saveAndGo(result.target, queryParams);
      }
    );
  }

  private saveAndGo(redirectTo: string, params: any) {
    this.sessionService.saveSession(this.session).subscribe(
      (result: any) => {
        const navigationExtras = {
          queryParams: params
        };
        this.router.navigate([redirectTo], navigationExtras);
      },
      err => {
        // todo: ?
      }
    );
  }

}



// WEBPACK FOOTER //
// ./client/app/goto/goto.component.ts